<template>
  <v-list>
    <OptionCard v-for="item in items" :key="item.title" :item="item" />
  </v-list>
</template>

<script>
import OptionCard from "./OptionCard";

export default {
  data: () => ({
    items: [
      { title: "Серверы", icon: "mdi-server-network", path: "/" },
      { title: "Товары", icon: "mdi-coffee-to-go", path: "/goods" },
      { title: "Комплекты", icon: "mdi-package-up", path: "/packages" },
    ],
  }),
  methods: {},
  components: {
    OptionCard,
  },
};
</script>
